export default class Survey {
    /**
     * Close status
     * @param status
     */
    public static statusClosed(status: any) {
        switch (status) {
            case 1:
            case 2:
            case 4:
            case 5:
            case 6:
            case 7: {
                return true;
            }
        }

        return false;
    }
}
